module.exports = __webpack_public_path__ + "img/platform-transactional.7b241566.png";